module.exports = __webpack_public_path__ + "static/media/head@2x.d7945c34.png";